import { toInt } from "./utils";

export function getHardwareConcurrency(): number {
  return toInt(navigator.hardwareConcurrency, -1);
}
